import React from 'react';
import { ShieldX, LogOut } from 'lucide-react';
import { useAuth } from '../auth/authProvider';
import { Button, Card } from '@license-management/ui';

const AccessDenied: React.FC = () => {
  const { logout, user } = useAuth();

  return (
    <div className="min-h-screen bg-zinc-900 bg-mesh flex flex-col justify-center items-center px-4">
      <Card className="text-center max-w-md p-8">
        <ShieldX className="mx-auto h-16 w-16 text-red-500" />
        <h1 className="mt-4 text-3xl font-bold text-zinc-900">Access Denied</h1>
        <p className="mt-2 text-zinc-600">
          Your account ({user?.email}) does not have permission to access any dashboard pages.
        </p>
        <p className="mt-1 text-sm text-zinc-500">
          Please contact your administrator to request access.
        </p>
        <Button
          onClick={logout}
          className="mt-6"
          leftIcon={<LogOut className="h-4 w-4" />}
        >
          Sign Out
        </Button>
      </Card>
    </div>
  );
};

export default AccessDenied;
